import { render, staticRenderFns } from "./TeamsStandingsTournament.vue?vue&type=template&id=27a98212&scoped=true"
import script from "./TeamsStandingsTournament.vue?vue&type=script&lang=js"
export * from "./TeamsStandingsTournament.vue?vue&type=script&lang=js"
import style0 from "./TeamsStandingsTournament.vue?vue&type=style&index=0&id=27a98212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a98212",
  null
  
)

export default component.exports